module.exports = __webpack_public_path__ + "static/img/Staff-Grad-Faculty Winners.7ffd62ba.jpg";